var _g, _path, _path2, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalkPt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 34,
    viewBox: "0 0 52 34",
    width: 52,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h52v34h-52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-27.183 1319.28 1.446-.7a1.357 1.357 0 0 1 .459-.08h8.612a1.323 1.323 0 0 1 .453.08l1.446.7",
    stroke: "#3a3a3a",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    transform: "translate(53.48 -1317.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.623 1v3.186",
    stroke: "#3a3a3a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-14.657 1340.837a1.081 1.081 0 0 1 1.081 1.083 1.082 1.082 0 0 1 -1.083 1.08 1.081 1.081 0 0 1 -1.081-1.081 1.083 1.083 0 0 1 1.083-1.082z",
    fill: "#3a3a3a",
    transform: "translate(53.48 -1317.504)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m-27.292 1340.837a1.081 1.081 0 0 1 1.082 1.082 1.081 1.081 0 0 1 -1.082 1.081 1.082 1.082 0 0 1 -1.082-1.081 1.081 1.081 0 0 1 1.081-1.083z",
    fill: "#3a3a3a",
    transform: "translate(53.48 -1317.504)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#3a3a3a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-30.316 1327.45c0-.373.551-.648 1.208-.679 5.792-.268 10.478-.229 16.268 0 .659.026 1.207.307 1.207.679",
    transform: "translate(53.48 -1317.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-11.635 1336.627c0 1.356-18.681 1.361-18.681 0",
    transform: "translate(53.48 -1317.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-26.472 1321.682h10.995a3.9 3.9 0 0 1 3.843 3.938v18.626a2.6 2.6 0 0 1 -2.236 2.158 67.87 67.87 0 0 1 -14.206 0 2.6 2.6 0 0 1 -2.24-2.163v-18.627a3.9 3.9 0 0 1 3.844-3.938z",
    transform: "translate(53.48 -1317.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.978 32.024h15.054"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-36.031 1332.455a2.31 2.31 0 0 1 -2.305-2.316 2.311 2.311 0 0 1 2.316-2.305 2.311 2.311 0 0 1 2.305 2.316 2.308 2.308 0 0 1 -2.312 2.3z",
    transform: "translate(53.48 -1317.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-42.48 1339.988a4.76 4.76 0 0 1 4.76-4.76",
    transform: "translate(53.48 -1317.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-40.1 1342.367c2.508 0 4.538 3.2 4.538 7.156",
    transform: "translate(53.48 -1317.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-32.961 1339.988a4.76 4.76 0 0 1 -4.759-4.76",
    transform: "translate(53.48 -1317.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.76 17.724-4.76 14.278"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkPt);
export default __webpack_public_path__ + "static/media/walk-pt.a9bb1112457d7bfd0ab7306f65e1b252.svg";
export { ForwardRef as ReactComponent };